import { Box, Snackbar, Alert } from "@mui/material";
import FloatingActionItems from "../../../pages/FloatingItems/FloatingActionItems";
import LeadsManagementTabs from "./LeadsManagementTabs";
import Leads from "./Leads/Leads";
import Analytics from "./Analytics/Analytics";
import { useLeadsManagementData } from "./hooks/useLeadsManagementData";

interface LeadsManagementProps {
  websiteSharedUid: string;
}

export default function LeadsManagement({
  websiteSharedUid,
}: LeadsManagementProps) {
  const leadsData = useLeadsManagementData(websiteSharedUid);

  return (
    <Box sx={{ px: 0.5, py: 0.25, backgroundColor: "#FFFFFF", minHeight: "100%", borderRadius: 1, boxShadow: 1, padding: "8px 16px" }}>
      <Box sx={{ mb: 0.5 }}>
        <Box
          component="h1"
          sx={{ m: 0, fontSize: 24, lineHeight: "32px", fontWeight: 400, color: "text.primary" }}
        >
          Leads Management
        </Box>
        <Box sx={{fontSize: 14, lineHeight: "20px", color: "text.secondary" }}>
          Review acquired leads, their scoring and brand outcome, report them to
          their brand partner, and analyze acquisition trends.
        </Box>
      </Box>

      {/* The page container's own padding (16px left/right, set on the
          outer Box above) applies to everything else on this page — the
          tabs alone need to sit flush against the page edges, so this
          negative margin cancels just that padding for this one section. */}
      <Box sx={{ mx: -2 }}>
        <LeadsManagementTabs
          view={leadsData.view}
          onChangeView={leadsData.setView}
        />
      </Box>

      {leadsData.view === "leads" ? (
        <Leads data={leadsData} />
      ) : (
        <Analytics data={leadsData} />
      )}

      <div data-tracker="940">
        <FloatingActionItems
          selectedSiteFloatingAction={websiteSharedUid}
          selectedDimensionsFloatingAction=""
          trackIdFloatingAction="941"
        />
      </div>

      <Snackbar
        open={!!leadsData.toastMessage}
        autoHideDuration={3400}
        onClose={leadsData.clearToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={leadsData.toastSeverity}
          onClose={leadsData.clearToast}
          sx={{ width: "100%" }}
        >
          {leadsData.toastMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
